import { ShieldAlert } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { PageShell } from "@/components/layout/PageShell";
import { AdminUsers } from "@/components/admin/AdminUsers";
import { useMe } from "@/context/MeContext";

const NotAllowed = () => (
  <div className="mx-auto max-w-xl px-4 py-24 text-center" data-testid="admin-not-allowed">
    <ShieldAlert className="mx-auto h-10 w-10 text-muted-foreground" />
    <h1 className="mt-4 font-display text-2xl font-bold">Admins only</h1>
    <p className="mt-2 text-sm text-muted-foreground">This page is for HubPilot administrators.</p>
  </div>
);

export default function Admin() {
  const { me } = useMe();
  return (
    <PageShell testId="admin-page">
      {me === undefined ? (
        <div className="mx-auto max-w-7xl px-4 py-14 sm:px-8"><Skeleton className="h-64 rounded-2xl" /></div>
      ) : me?.role === "admin" ? <AdminUsers /> : <NotAllowed />}
    </PageShell>
  );
}
